<template>
  <App>
    <div class="card card-flush">
      <div class="card-body">
        <div class="row">
          <div class="col-3">
            <!--begin::Reward Tier-->
            <a :href="route('app.relatorios.download.avaliadores')" target="_blank" class="card bg-info hoverable h-md-100">
              <!--begin::Body-->
              <div class="card-body">
                <!--begin::Svg Icon | path: icons/duotune/general/gen020.svg-->
                <span class="svg-icon svg-icon-white svg-icon-3x ms-n1">
                 <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 01-2.25 2.25M16.5 7.5V18a2.25 2.25 0 002.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 002.25 2.25h13.5M6 7.5h3v3H6v-3z" />
                  </svg>
                </span>
                <!--end::Svg Icon-->
                <div class="text-white fw-bolder fs-2 mt-5">Avaliadores</div>
                <div class="fw-bold text-white">Exporte para excel o relatório dos avaliadores com área de atuação.</div>
              </div>
              <!--end::Body-->
            </a>
            <!--end::Reward Tier-->
          </div>
        </div>
      </div>
    </div>
  </App>
</template>
<script>
import App from "@layout/App";
import {Link} from "@inertiajs/inertia-vue3";
import SubmitButton from "@forms/SubmitButton";
import Datepicker from "@forms/Datepicker";
import FormGroup from "@forms/FormGroup";
import axios from "axios";

export default {
  props: [],

  components: {
    FormGroup,
    Datepicker,
    SubmitButton,
    App,
    Link,
  },

  data: _ => ({

  }),

  mounted() {
    this.init();
  },

  methods: {
    init() {
      this.emitter.emit('title', 'Relatório de Avaliadores');
      this.emitter.emit('breadcrumb', [
        {title: 'Dashboard', link: 'app.home'},
        {title: 'Relatório de Avaliadores'},
      ]);

      this.emitter.emit('action', {
          show: false,
        }
      );
    },
    downloadProjeto() {
      axios.get()
    }
  },
};
</script>
